export default "__VITE_ASSET__7b15d2d6__"